import * as React from "react";
import { withTheme, WithTheme, Typography } from "@material-ui/core";
import { ActionHistory } from "../../types/ActionHistory";
import { getDate } from "../../helper/functions.helper";

interface ActionHistoryItemProps {
    actionHistory: ActionHistory;
}

class ActionHistoryItem extends React.Component<ActionHistoryItemProps & WithTheme> {

    public render() {
        if ( !this.props.actionHistory ) {
            return "";
        }

        return (           
            <Typography variant="body1" style={{fontWeight: 500 }}>
               <span style={{fontWeight: 100 }}>{this.getLabel()}</span>{getDate(this.props.actionHistory.date, "big")}
            </Typography>
        );
    }

    private getLabel() {
        let label = "";
        
        switch ( this.props.actionHistory.type ) {
            case "proposition" :
                label += "Proposition ";
                break;
            case "adhesion" :
                label += "Adhésion ";
                break;
            default:

        }
        
        switch ( this.props.actionHistory.action ) {
            case "creation" :
                label += "créée le ";
                break;
            case "send" :
                label += "envoyée le ";
                break;
            case "print" :
                label += "imprimée le ";
                break;
            case "download" :
                label += "téléchargée le ";
                break;
            default: 
        }
        return label;
    }

}

export default withTheme()(ActionHistoryItem);


// WEBPACK FOOTER //
// ./src/components/ActionHistoryItem/ActionHistoryItem.tsx